module.exports = __webpack_public_path__ + "img/gaokao_pre_top.5cf3b285.png";